import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { useAuth } from "../provider/authProvider";
import { ProtectedRoute } from "./ProtectedRoute";
import LoginPage from "../components/LoginPage";
import MainPage from "../components/MainPage";
import ForgotPassword from "../components/ForgotPassword";
import ResetPassword from "../components/ResetPassword";

const Routes = () => {
  const { token } = useAuth();

  

  // Define public routes accessible to all users
  const routesForPublic = [
    {
      path: "/login",
      element: <LoginPage/>,
    },    
    
  ];

  // Define routes accessible only to authenticated users
  const routesForAuthenticatedOnly = [
    {
      path: "/",
      element: <ProtectedRoute />, // Wrap the component in ProtectedRoute
      children: [
        {
          path: "/",
          element: <MainPage/>,
        },        
      ],
    },
  ];

  // Define routes accessible only to non-authenticated users
  const routesForNotAuthenticatedOnly = [    
    {
      path: "/login",
      element: <LoginPage/>,
    },
  ];

  const routesForForgotPassword = [    
    {
      path: "/forgotPassword",
      element: <ForgotPassword/>,
    },
  ];

  const routesForResetPassword = [    
    {
      path: "/resetPassword/:token",
      element: <ResetPassword/>,
    },
  ];

  // Combine and conditionally include routes based on authentication status
  const router = createBrowserRouter([
    ...routesForPublic,
    ...(!token ? routesForNotAuthenticatedOnly : []),
    ...routesForAuthenticatedOnly,
    ...routesForForgotPassword,
    ...routesForResetPassword,
  ]);

  // Provide the router configuration using RouterProvider
  return <RouterProvider router={router} />;
  
};

export default Routes;